const hasGroup = (object, arg) => {
  const groupName = String(arg)

  if ('user_groups' in object) { // Это объект request
    return object.user?.is_superuser || object.user_groups.includes(groupName)
  }

  // Это объект models.User
  return object.is_superuser || object.groups.findIndex(group => group.name === groupName) !== -1
}

export default hasGroup
